import { createAction, props } from '@ngrx/store';
import { Language } from '@spartacus/core';

import { SITE_CONTEXT_ACTIONS } from '../site-context-actions.type';

export const getLanguagesAction = createAction(SITE_CONTEXT_ACTIONS.GET_LANGUAGES, props<{ payload: string }>());
export const loadLanguagesAction = createAction(SITE_CONTEXT_ACTIONS.LOAD_LANGUAGES, props<{ payload: string }>());
export const loadLanguagesSuccessAction = createAction(
  SITE_CONTEXT_ACTIONS.LOAD_LANGUAGES_SUCCESS,
  props<{ payload: Language[] }>(),
);
